// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

:root {
  --nb-of-players: 0;
}

.App {
  background-size: 15%;
  background-repeat: repeat;
  background-position: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
}

.LineList {
  position: absolute;
  top: 0;
  margin-top: 5vh;
  width: 100vw;
  height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n:root {\n  --nb-of-players: 0;\n}\n\n.App {\n  background-size: 15%;\n  background-repeat: repeat;\n  background-position: center;\n  flex-direction: column;\n  width: 100vw;\n  height: 100vh;\n}\n\n.LineList {\n  position: absolute;\n  top: 0;\n  margin-top: 5vh;\n  width: 100vw;\n  height: 95vh;\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
